import $ from 'jquery';

const sectionOne = document.querySelector('.configure-bottom-bar');

// Observe Sticky
if (sectionOne) {
  const observeOptions = {threshold: 0.2};
  
  const configObserver = new IntersectionObserver(function (entries, observer) {
    const configureSticky = $('#configure-sticky-overview');

    if (!entries[0].isIntersecting) {
      // show the sticky
      configureSticky.removeClass('inactive');
    } else {
      // hide the sticky
      configureSticky.addClass('inactive');
    }
  }, observeOptions);

  configObserver.observe(sectionOne);
}
